import { Controller } from '../../../helpers/controllers/Controller'

export class BranchesController extends Controller {

    constructor() {
        super('/shop/points', '/shop/branches', true)
    }

}